import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';

export const HeaderContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  flex: 1,
  backgroundColor: theme.palette.background.main,
  padding: theme.spacing(0, 1.25, 0, 1.25),
  maxHeight: '74px',
}));

export const OrderStatus = styled(Box)(({ theme }) => ({
  justifyContent: 'flex-end',
  textAlign: 'center',
  flexDirection: 'column',
  padding: theme.spacing(1.25),
}));
